import { z } from "zod";
import type { Language } from "../i18n/I18n";

export const createOrderFormSchema = (language: Language) => {
  const en = language === "en";
  return z.object({
  name: z.string().trim().min(2, en ? "Enter at least 2 characters" : "Вкажіть щонайменше 2 символи").max(60, en ? "Name is too long" : "Ім’я надто довге"),
  phone: z.string().trim()
    .transform((value) => value.replace(/[\s()-]/g, ""))
    .refine((value) => /^\+380\d{9}$/.test(value), en ? "Enter a number in +380XXXXXXXXX format" : "Введіть номер у форматі +380XXXXXXXXX"),
  email: z.string().trim()
    .refine((value) => value === "" || z.string().email().safeParse(value).success, en ? "Check the email address" : "Перевірте адресу електронної пошти"),
  });
};

export type OrderFormValues = z.input<ReturnType<typeof createOrderFormSchema>>;
